import React from "react";
import { Row, Col, Spinner, Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../reducers";

const Loading = () => {
  const isDisabledSite = useSelector((state: RootState) => state.shop.isDisabledSite);

  return (
    <Row className="text-center mt-4">
      <Col>
        {isDisabledSite ? (
          <Alert variant={"success"}>
            <h3>Estamos actualizando el stock volvé a ingresar en un rato</h3>
          </Alert>
        ) : (
          <Spinner animation="border" role="status" />
        )}
      </Col>
    </Row>
  );
};

export default Loading;
